/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./call-icon.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./call-icon.component";
import * as i3 from "../web-widget/web-widget.service";
var styles_CallIconComponent = [i0.styles];
var RenderType_CallIconComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CallIconComponent, data: {} });
export { RenderType_CallIconComponent as RenderType_CallIconComponent };
export function View_CallIconComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "span", [["class", "material-icons click-to-call"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.openClickToCallWidget(_co.number) !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵted(-1, null, ["call"]))], null, null); }
export function View_CallIconComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-call-icon", [], null, null, null, View_CallIconComponent_0, RenderType_CallIconComponent)), i1.ɵdid(1, 114688, null, 0, i2.CallIconComponent, [i3.WebWidgetService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CallIconComponentNgFactory = i1.ɵccf("cc-call-icon", i2.CallIconComponent, View_CallIconComponent_Host_0, { number: "number" }, {}, []);
export { CallIconComponentNgFactory as CallIconComponentNgFactory };
